import { apiRequest } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function validateCoupon({ code, planId }) {
  return apiRequest('/api/coupons/validate', {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({
      code: String(code || '').trim(),
      plan_id: Number(planId),
    }),
  });
}

export async function getActiveCoupons() {
  return apiRequest('/api/coupons', {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}
